import { selectPlaygroundEditMode, selectPlaygroundOthers } from 'containers/Playground/playgroundSlice'
import { useReduxSelector } from 'store'
import Other from './Other'
import React from 'react'

const OthersList: React.FC = () => {
  const others = useReduxSelector(selectPlaygroundOthers)
  const isEditMode = useReduxSelector(selectPlaygroundEditMode)
  const objectsRef = React.useRef<HTMLDivElement>(null)

  return (
    <div
      ref={objectsRef}
      className='playground__objects'>
      {others.map((e, idx) => <Other
        {...e}
        key={idx}
        isEditMode={isEditMode} />)}
    </div>
  )
}


export default OthersList